































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { UserInfo } from '../../../../../../../../../../../models/getUserInfo/GetUserInfo'
import { VueComponent } from '../../../../../../../../../../../shared/types/VueComponent'
import { PlaceholdersOnes } from '../../../../../../../../../../Editor/components/Toolbar/types'
import { AvailableButtonsTypes } from '../../../../../../../../../../MessageEditorWithMedia/components/ButtonsConstructor/types'
import MessageEditorWithMediaData from '../../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import CustomEditor from '../../../../../../../Editor/CustomEditor'
import UserInfoHelper from '../../../../../../../Helpers/UserInfoHelper'
import { ActionNode } from '../../../../logic/ActionNode'
import { NotifyUsersActionProxy } from '../../../../logic/Actions/NotifyUsersAction/NotifyUsersActionProxy'
import { ActionNodeProps } from '../../../../logic/types'
import NotifyUsersActionAddUserField from './components/NotifyUsersActionAddUserField.vue'
import NotifyUsersActionMessageSettings from './components/NotifyUsersActionMessageSettings.vue'
import NotifyUsersActionTable from './components/NotifyUsersActionTable.vue'

@Component({
  components: {
    NotifyUsersActionAddUserField,
    NotifyUsersActionTable,
    NotifyUsersActionMessageSettings,
  }
})
export default class NotifyUsersAction extends Vue {
  @Prop() action!: NotifyUsersActionProxy

  @Prop() editor!: CustomEditor

  @Prop() node!: ActionNode

  @Prop() availableButtonsTypes!: AvailableButtonsTypes

  @Prop() buttonsHelpView!: VueComponent | string

  @Prop() placeholders!: PlaceholdersOnes

  @Prop() creatingOutputs!: boolean

  @Prop() board!: string

  @Prop() usersOptions!: ActionNodeProps['usersOptions']

  userData = ''

  isLoading = false

  get users(): Array<UserInfo | { value: string | number, error: string }> {
    const users: Array<UserInfo> = []

    this.action.action.users.forEach((u) => {
      const user = UserInfoHelper.getUser(u)

      if (user) {
        users.push(user)
      }
    })

    return [
      ...this.action.notFoundUsers.map((u) => ({
        value: u,
        error: this.$t('flow_get_user_info_user_not_found').toString()
      })),
      ...users,
    ]
  }

  setMessages(messages: Array<MessageEditorWithMediaData>): void {
    this.action.setMessages(messages, this.creatingOutputs, this.node, this.editor)
  }
}
